import { adminAuthenticationImpersonatedUserTokenGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminAuthenticationImpersonatedUserTokenReducers = combineReducers({
	get: adminAuthenticationImpersonatedUserTokenGetSlice.asyncReducers
});

export const adminAuthenticationImpersonatedUserTokenWatchers = combineAllWatchers([
	adminAuthenticationImpersonatedUserTokenGetSlice.asyncWatchers
]);
